import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { yupResolver } from '@hookform/resolvers/yup';
import { connect } from 'react-redux';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { getEvent } from '~/selectors/event';
import { updatePreNeedViewer } from '~/api/NewViewer';
import { Input } from '~/elements/Input';
import schema from './emailOnlyForm.schema';
import Loader from '~/elements/Loader';
import { Form, SubmitButton, TermsAndConditions } from '~/components/PreNeedPopup/twoStepsPreNeedPopup.styles';
import { useEmailOnlyForm } from './emailOnlyForm.logic';
import { getCustomConfig } from '~/selectors/event';
import { parseCustomConfig } from '~/utils/helpers';
const EmailOnlyForm = (props) => {
    const { loading, setLoading, contactData } = useEmailOnlyForm(Number(props.event.id));
    const customPreNeedUI = props.customConfig?.customPreNeedUI ? parseCustomConfig(props.customConfig?.customPreNeedUI) : undefined;
    const { control, handleSubmit, reset } = useForm({
        resolver: yupResolver(schema()),
        defaultValues: contactData,
    });
    useEffect(() => {
        reset(contactData);
    }, [contactData]);
    const onSubmit = handleSubmit(async (data) => {
        setLoading(true);
        try {
            await updatePreNeedViewer(Number(props.event.id), contactData.fullName, data.oldEmail, data.email, contactData.mobile, contactData.zip || '', props.preNeedOption);
            props.onRegister();
        }
        catch (error) {
            console.error('updatePreNeedViewer error:', error);
        }
        finally {
            setLoading(false);
        }
    });
    const preNeedFormDisclaimer = customPreNeedUI?.preNeedFormDisclaimer ?? undefined;
    return (_jsxs(Form, { onSubmit: onSubmit, children: [_jsx(Input, { type: "email", name: "email", control: control, isRequired: true }), _jsx("input", { name: "oldEmail", type: "hidden", value: contactData.oldEmail }), _jsx(SubmitButton, { disabled: loading, children: loading ? _jsx(Loader, { size: 24, color: "white" }) : 'Submit Request' }), preNeedFormDisclaimer ? (_jsx(TermsAndConditions, { dangerouslySetInnerHTML: { __html: preNeedFormDisclaimer } })) : (_jsxs(TermsAndConditions, { children: ['Your information will be handled in accordance\n with our', " ", _jsx("a", { href: "https://www.oneroomstreaming.com/terms-and-conditions", target: "_blank", rel: "noreferrer", children: "T&C's" }), " and ", _jsx("a", { href: "https://www.oneroomstreaming.com/privacy-policy", target: "_blank", rel: "noreferrer", children: "Privacy Policy" }), "."] }))] }));
};
const mapStateToProps = (state) => ({
    event: getEvent(state),
    customConfig: getCustomConfig(state),
});
export default connect(mapStateToProps)(EmailOnlyForm);
